import ViewFixture from "./ViewFixture";
export default ViewFixture;
